import React from "react"
import { conversationShape } from "utils/propTypeShapes"
import ConversationActionClose from "./ConversationActionClose"
import ConversationActionReopen from "./ConversationActionReopen"

const ConversationActions = ({ conversation }) => {
  const { closed, id } = conversation

  return (
    <div className="flex flex-row justify-center w-full">
      {
        closed
          ? <ConversationActionReopen conversationId={id} />
          : <ConversationActionClose conversationId={id} />
      }
    </div>
  )
}

ConversationActions.propTypes = {
  conversation: conversationShape.isRequired,
}

export default ConversationActions
